import type { Anime } from "./types";

export const animeList: Anime[] = [
  {
    id: "a01",
    title: "星海列车",
    jpTitle: "ステラ・トレイン",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20key%20visual%20portrait%20poster%2C%20a%20teenage%20girl%20in%20a%20white%20sailor%20jacket%20standing%20on%20the%20deck%20of%20a%20vintage%20space%20train%2C%20glowing%20star%20sky%20with%20nebula%20clouds%20behind%20her%2C%20warm%20orange%20and%20cream%20color%20palette%2C%20clean%20simple%20flat%20background%2C%20high%20detail%20illustration%2C%20vertical%20composition&width=600&height=850&seq=anime-a01-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20wide%20key%20visual%2C%20vintage%20space%20train%20traveling%20across%20a%20sea%20of%20stars%2C%20two%20young%20travelers%20silhouetted%20at%20the%20window%2C%20warm%20orange%20and%20deep%20teal%20harmony%2C%20soft%20glow%2C%20painterly%20cinematic%20anime%20background%20art%2C%20no%20text&width=1600&height=900&seq=anime-a01-banner-v2&orientation=landscape",
    genres: ["奇幻", "冒险", "治愈"],
    region: "日本",
    year: 2025,
    episodes: "全 24 话",
    status: "连载中",
    rating: 9.2,
    heat: 98600,
    updatedAt: "2025-10-16",
    summary: "一趟穿梭星海的列车，载着少年少女寻找失落的站台。温柔又壮阔的成长物语。",
    intro: [
      "在银河的边缘，有一列只在深夜出现的列车。它没有固定的线路，只停靠在那些被人们遗忘的站台。十六岁的见习乘务员雾子在某个雨夜登上了这趟列车，从此开始了一段跨越星海的旅程。",
      "作品以「旅途」为核心意象，用单元剧的形式讲述每一位乘客的故事：等待故人的旅人、寻找故乡的少年、与时间赛跑的画家。每一个故事都像一节温暖的车厢，缓缓驶向观众心里。",
      "动画由新锐工作室云间制作，美术监督擅长以油画质感的天空与光影构建场景，配乐则以钢琴与手风琴为主，被观众称为「能听见星光的作品」。",
    ],
    reasons: [
      "单元剧节奏舒缓，适合深夜一口气看到天亮",
      "美术与配乐双双出彩，画面几乎每一帧都能当壁纸",
      "主题围绕告别与重逢，情绪表达克制但有力量",
    ],
    staff: [
      { role: "导演", name: "柏木遥" },
      { role: "系列构成", name: "藤井忍" },
      { role: "角色设计", name: "白川澪" },
      { role: "音乐", name: "三轮光太" },
    ],
    characters: [
      { name: "雾子", cv: "天野琴音", desc: "见习乘务员，擅长记住每一位乘客的名字。" },
      { name: "阿澈", cv: "佐仓凉", desc: "神秘的修车少年，能听出列车行驶中的异常。" },
      { name: "列车长", cv: "大谷六郎", desc: "永远戴着一顶旧礼帽，据说已经在这儿工作了三百年。" },
    ],
    tags: ["星空", "单元剧", "治愈系", "冒险"],
    studio: "云间动画制作",
  },
  {
    id: "a02",
    title: "裂界武斗",
    jpTitle: "ブレイク・バウンド",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20action%20key%20visual%20poster%2C%20a%20muscular%20young%20fighter%20with%20fiery%20orange%20aura%20punching%20through%20cracked%20dimension%20glass%2C%20dynamic%20pose%2C%20high%20contrast%20warm%20red%20and%20cream%20background%2C%20dramatic%20anime%20illustration%20style%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a02-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20battle%20scene%20wide%20shot%2C%20two%20fighters%20clashing%20mid%20air%20above%20a%20shattered%20city%20skyline%2C%20orange%20energy%20explosions%2C%20speed%20lines%2C%20animate%20action%20cinematic%20composition%2C%20warm%20color%20grading%2C%20no%20text&width=1600&height=900&seq=anime-a02-banner-v2&orientation=landscape",
    genres: ["热血", "奇幻", "科幻"],
    region: "日本",
    year: 2025,
    episodes: "全 12 话",
    status: "连载中",
    rating: 8.9,
    heat: 142300,
    updatedAt: "2025-10-17",
    summary: "当空间开始碎裂，少年用拳头把世界拼回来。极具冲击力的格斗动画。",
    intro: [
      "某天凌晨，城市上空出现了无数道青色裂缝，从裂缝中涌出的异兽把街区变成了战场。普通高中生玄武在一次意外中觉醒了「裂拳」的力量，成为极少数能徒手修复空间裂痕的人。",
      "本作最大看点是把「空间修复」这一设定和格斗演出结合：每一次出拳都伴随着玻璃碎裂般的空间纹路，打斗节奏极快，被动作作画爱好者称为「今年的肾上腺素担当」。",
      "前三话的追车戏与天台战使用了大量一镜到底的分镜，动作设计参考了实拍格斗与跑酷，适合喜欢高密度动作场面的观众。",
    ],
    reasons: ["动作作画密度极高，几乎每集都有名场面", "设定新颖，空间修复与格斗结合得很自然", "主角成长线清晰，配角各有高光"],
    staff: [
      { role: "导演", name: "黑田悟" },
      { role: "系列构成", name: "伊藤岭" },
      { role: "角色设计", name: "南云直" },
      { role: "音乐", name: "ODDLINE" },
    ],
    characters: [
      { name: "玄武", cv: "神谷亮介", desc: "觉醒裂拳的高中生，嘴上说着不想打，身体很诚实。" },
      { name: "伊织", cv: "早濑千夏", desc: "裂缝研究会的会长，负责用数据给玄武做战术支援。" },
      { name: "九号", cv: "三宅玄", desc: "来自裂缝另一侧的存在，立场摇摆。" },
    ],
    tags: ["战斗", "异能", "爽番", "空间"],
    studio: "赤羽工作室",
  },
  {
    id: "a03",
    title: "周六的猫町咖啡",
    jpTitle: "土曜日のネコマチ喫茶",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20slice%20of%20life%20poster%2C%20a%20cozy%20cafe%20interior%20with%20warm%20cream%20walls%2C%20two%20cat%20ears%20wearing%20cafe%20staff%20standing%20behind%20the%20counter%2C%20sunlight%20through%20lace%20curtains%2C%20soft%20pastel%20palette%20with%20a%20touch%20of%20orange%2C%20gentle%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a03-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20healing%20scene%20wide%20shot%2C%20sunlit%20small%20town%20street%20with%20a%20cafe%20terrace%2C%20cats%20napping%20on%20wooden%20benches%2C%20warm%20cream%20and%20light%20orange%20palette%2C%20soft%20watercolor%20anime%20background%2C%20peaceful%20atmosphere%2C%20no%20text&width=1600&height=900&seq=anime-a03-banner-v2&orientation=landscape",
    genres: ["日常", "治愈", "恋爱"],
    region: "日本",
    year: 2024,
    episodes: "全 12 话",
    status: "已完结",
    rating: 8.7,
    heat: 76800,
    updatedAt: "2025-09-28",
    summary: "小镇角落的猫町咖啡，只在下雨天营业。慢节奏的日常治愈系代表作。",
    intro: [
      "在一座地图上几乎找不到的小镇，有一家只在雨天开门的老咖啡馆。店里的店员都是能变成人形的猫，而店主则是一位从未露面的神秘老人。",
      "故事从刚搬到小镇的大学新生千代推开那扇木门开始。一杯慢慢冲出的手冲咖啡，一段段客人带来的小小烦恼，构成了这部作品的全部。",
      "没有宏大的冒险，也没有激烈的冲突。它只是安静地讲述「在某个下雨的午后，有人愿意陪你坐一会儿」这件事，因此被很多观众当作睡前放松首选。",
    ],
    reasons: ["画面温暖治愈，台词细腻生活化", "每集一个客人故事，适合碎片时间观看", "对咖啡与小镇的描写非常用心，细节丰富"],
    staff: [
      { role: "导演", name: "小野寺春" },
      { role: "系列构成", name: "冈田凉子" },
      { role: "角色设计", name: "花村柚" },
      { role: "音乐", name: "森川灯" },
    ],
    characters: [
      { name: "千代", cv: "白石桃", desc: "搬到小镇的大学新生，社恐但好奇心旺盛。" },
      { name: "莉莉", cv: "中村明里", desc: "店里的橘猫店员，态度傲娇，手冲技术一流。" },
      { name: "阿墨", cv: "宫田健", desc: "沉默的黑猫店长代理，只在凌晨出现。" },
    ],
    tags: ["日常", "咖啡", "猫", "慢节奏"],
    studio: "晴耕社",
  },
  {
    id: "a04",
    title: "雾港疑案",
    jpTitle: "ミストハーバー",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20mystery%20noir%20poster%2C%20a%20detective%20in%20a%20long%20beige%20trench%20coat%20standing%20on%20a%20foggy%20harbor%20pier%2C%20muted%20grey%20green%20and%20vintage%20amber%20palette%2C%20single%20warm%20street%20lamp%2C%20cinematic%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a04-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20mystery%20atmosphere%20wide%20shot%2C%20foggy%20harbor%20town%20at%20dusk%2C%20old%20warehouses%20and%20moored%20ships%2C%20a%20single%20figure%20walking%20under%20amber%20lamplight%2C%20muted%20teal%20and%20warm%20ochre%20tones%2C%20cinematic%20anime%20background%20art%2C%20no%20text&width=1600&height=900&seq=anime-a04-banner-v2&orientation=landscape",
    genres: ["悬疑", "推理"],
    region: "日本",
    year: 2024,
    episodes: "全 13 话",
    status: "已完结",
    rating: 9.0,
    heat: 63100,
    updatedAt: "2025-09-12",
    summary: "一座终年有雾的港口城市，一件跨越三十年的失踪案，一段被抹去的记忆。",
    intro: [
      "雾港是一个常年被海雾笼罩的城市，据说这里的人有一半都做过同一个梦：梦见一艘永远不出港的白船。私家侦探久住接手了一桩看似普通的寻人委托，却在调查中发现案件与自己童年的失踪事件有关。",
      "整部作品采用冷调的画面与克制的叙事，线索埋得很深，几乎每一句闲聊都是伏笔。第十三话的收束让不少观众回看了前三话的细节。",
      "如果你喜欢「看完想立刻找人讨论」的推理作品，这部值得排进片单。",
    ],
    reasons: ["伏笔回收干净利落，结构工整", "冷色调美术营造出极强的氛围感", "主角与委托人的关系处理得很有层次"],
    staff: [
      { role: "导演", name: "重田真一" },
      { role: "系列构成", name: "野间绫" },
      { role: "角色设计", name: "五十岚修" },
      { role: "音乐", name: "夜雾回廊" },
    ],
    characters: [
      { name: "久住诚", cv: "大塚清", desc: "私家侦探，习惯在结案后一个人去港口抽一支烟。" },
      { name: "雨宫莲", cv: "远藤玲", desc: "委托人，寻找三十年前失踪的姐姐。" },
      { name: "老船长", cv: "田边修三", desc: "知晓雾港旧事的老人，说话永远只说一半。" },
    ],
    tags: ["推理", "氛围向", "悬疑", "冷色调"],
    studio: "雾灯映画",
  },
  {
    id: "a05",
    title: "剑起长安",
    jpTitle: "長安の剣",
    cover:
      "https://readdy.ai/api/search-image?query=Chinese%20animation%20key%20visual%20poster%2C%20a%20young%20swordsman%20in%20flowing%20white%20hanfu%20holding%20a%20jade%20hilted%20sword%2C%20ancient%20Chinese%20city%20rooftops%20and%20orange%20lanterns%20behind%2C%20ink%20wash%20texture%20mixed%20with%20warm%20orange%20sunset%2C%20vertical%20composition%2C%20high%20detail&width=600&height=850&seq=anime-a05-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Chinese%20animation%20wide%20banner%2C%20ancient%20Changan%20city%20at%20dusk%20with%20thousands%20of%20orange%20lanterns%2C%20a%20lone%20swordsman%20standing%20on%20a%20temple%20roof%2C%20ink%20wash%20brush%20texture%2C%20warm%20sunset%20gradient%2C%20cinematic%20composition%2C%20no%20text&width=1600&height=900&seq=anime-a05-banner-v2&orientation=landscape",
    genres: ["热血", "奇幻", "冒险"],
    region: "中国",
    year: 2025,
    episodes: "全 26 话",
    status: "连载中",
    rating: 9.1,
    heat: 121500,
    updatedAt: "2025-10-15",
    summary: "水墨国风与热血剑斗的碰撞，一部把长安画进江湖里的国产动画。",
    intro: [
      "长安城有一位不出名的少年剑客，他的剑从不伤人，只斩断执念。为了让被贬入凡间的师父重归仙班，他必须在一年内收集九道「剑意」。",
      "本作在美术上大量使用水墨笔触与敦煌壁画的配色，打斗镜头以长镜头与泼墨特效结合，形成了独特的视觉语言。音乐融合了箜篌、琵琶与电子音色。",
      "剧情上，每一道剑意都对应一段人间故事，从市井到边关，从书生到商贾，把长安的烟火气描得相当扎实。",
    ],
    reasons: ["国风水墨美术辨识度极高", "剑斗分镜干净利落，配乐燃点足", "每集一个剑意故事，结构清晰"],
    staff: [
      { role: "总导演", name: "林承舟" },
      { role: "编剧", name: "苏若水" },
      { role: "美术总监", name: "陈墨白" },
      { role: "音乐", name: "长歌乐团" },
    ],
    characters: [
      { name: "谢云归", cv: "顾清川", desc: "少年剑客，剑不出鞘，出鞘必见执念。" },
      { name: "阿蛮", cv: "叶小满", desc: "长安城的小报信人，消息比谁都灵通。" },
      { name: "老道士", cv: "周砚", desc: "被贬凡间的师父，最爱在酒馆里讲旧事。" },
    ],
    tags: ["国风", "剑客", "水墨", "江湖"],
    studio: "长歌动画",
  },
  {
    id: "a06",
    title: "第七轨道",
    jpTitle: "セブンス・オービット",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20sci-fi%20mecha%20poster%2C%20a%20sleek%20white%20and%20orange%20humanoid%20robot%20standing%20in%20a%20space%20elevator%20hangar%2C%20a%20young%20pilot%20in%20a%20flight%20suit%20beside%20it%2C%20clean%20industrial%20background%20with%20soft%20glow%2C%20modern%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a06-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20sci-fi%20wide%20shot%2C%20space%20elevator%20rising%20above%20earth%20orbit%2C%20massive%20white%20mecha%20silhouettes%20against%20a%20warm%20orange%20planet%20horizon%2C%20stars%20and%20debris%2C%20clean%20futuristic%20anime%20art%2C%20no%20text&width=1600&height=900&seq=anime-a06-banner-v2&orientation=landscape",
    genres: ["科幻", "悬疑", "热血"],
    region: "日本",
    year: 2023,
    episodes: "全 24 话",
    status: "已完结",
    rating: 8.6,
    heat: 58400,
    updatedAt: "2025-08-30",
    summary: "空间站在第七轨道失联，唯一幸存的少年驾驶员必须找出真相。",
    intro: [
      "地球与月球之间的第七轨道空间站突然与地面失联，救援队抵达时只找到一个还在维生舱里的少年。他失去了三年的记忆，却记得有一台机甲的启动口令。",
      "作品把机甲战斗和封闭空间的悬疑结合，每一集都在推进一个新的谜团。机设偏向写实工业风，战斗动作参考了真实的航天器姿态控制，硬核程度较高。",
      "第二季信息目前尚未公布，但官方在活动上提到「故事还有一半没讲」，值得期待。",
    ],
    reasons: ["机甲设定硬核写实，细节考究", "封闭空间悬疑拉满，节奏紧凑", "群像塑造有层次，配角也有弧光"],
    staff: [
      { role: "导演", name: "有马隼人" },
      { role: "系列构成", name: "神崎升" },
      { role: "机械设计", name: "石川工房" },
      { role: "音乐", name: "HALO / 铃木苍" },
    ],
    characters: [
      { name: "苍井零", cv: "小林悠真", desc: "失忆的少年驾驶员，对第七轨道有莫名的熟悉感。" },
      { name: "艾玛", cv: "蕾娜·柯林斯", desc: "救援队 AI 工程师，情绪比 AI 还稳定。" },
      { name: "指挥官", cv: "坂本彻", desc: "第七轨道失联事件的决策者。" },
    ],
    tags: ["机甲", "太空", "硬核", "悬疑"],
    studio: "轨道制作委员会",
  },
  {
    id: "a07",
    title: "夏日回声",
    jpTitle: "サマーエコー",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20romance%20poster%2C%20two%20teenagers%20standing%20on%20a%20seaside%20concrete%20staircase%20in%20bright%20summer%20sunlight%2C%20wind%20blowing%20hair%2C%20white%20shirt%20and%20pale%20orange%20skirt%2C%20clear%20blue%20sky%20with%20clouds%2C%20nostalgic%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a07-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20summer%20nostalgia%20wide%20shot%2C%20seaside%20town%20railway%20crossing%20in%20golden%20afternoon%20light%2C%20two%20students%20walking%20with%20bicycles%2C%20power%20lines%20and%20clouds%2C%20warm%20sunlit%20pastel%20color%20grading%2C%20gentle%20anime%20background%20art%2C%20no%20text&width=1600&height=900&seq=anime-a07-banner-v2&orientation=landscape",
    genres: ["恋爱", "治愈", "日常"],
    region: "日本",
    year: 2022,
    episodes: "全 12 话",
    status: "已完结",
    rating: 8.4,
    heat: 47300,
    updatedAt: "2025-07-21",
    summary: "一个夏天，一段没有说出口的话，和一段会一直响下去的回声。",
    intro: [
      "海边小镇的高二暑假，转学生千夏与旧友之间的一个约定被重新提起。作品用两条时间线交错展开，一边是现在的夏天，一边是十年前同样的夏天。",
      "本作把「没能说出口的告白」处理得非常克制，全片几乎没有煽情音乐，却在一场海边的雨戏里把所有情绪释放了出来。",
      "适合喜欢细腻青春叙事的观众，尤其是喜欢实景感美术风格的朋友。",
    ],
    reasons: ["叙事克制，情绪后劲足", "海边小镇场景还原度高，氛围极佳", "音乐与留白的搭配非常聪明"],
    staff: [
      { role: "导演", name: "柴田千寻" },
      { role: "系列构成", name: "水野遥" },
      { role: "角色设计", name: "大森咲" },
      { role: "音乐", name: "夏川音" },
    ],
    characters: [
      { name: "千夏", cv: "内田真白", desc: "暑假转学来的少女，随身带着一台旧相机。" },
      { name: "凉太", cv: "高桥直", desc: "本地少年，暑假里最忙的人。" },
      { name: "阿滨", cv: "山本大辉", desc: "凉太的死党，负责把沉默的两个人推到一起。" },
    ],
    tags: ["青春", "海边", "夏天", "细腻"],
    studio: "潮风制作",
  },
  {
    id: "a08",
    title: "机械师与花",
    jpTitle: "機械技師と花",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20art%20poster%2C%20a%20female%20mechanic%20in%20a%20brown%20leather%20apron%20holding%20a%20single%20orange%20flower%2C%20a%20friendly%20round%20robot%20beside%20her%2C%20warm%20workshop%20background%20with%20brass%20parts%2C%20warm%20amber%20and%20cream%20palette%2C%20detailed%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a08-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20wide%20shot%2C%20cozy%20workshop%20full%20of%20brass%20gears%20and%20potted%20plants%2C%20sunlight%20through%20tall%20windows%2C%20a%20female%20mechanic%20repairing%20a%20small%20robot%2C%20warm%20amber%20and%20cream%20palette%2C%20painterly%20anime%20art%2C%20no%20text&width=1600&height=900&seq=anime-a08-banner-v2&orientation=landscape",
    genres: ["治愈", "科幻", "日常"],
    region: "日本",
    year: 2023,
    episodes: "全 12 话",
    status: "已完结",
    rating: 8.5,
    heat: 39600,
    updatedAt: "2025-06-18",
    summary: "一个修理旧机器的女孩，和一台坚持要开花的小机器人。",
    intro: [
      "在蒸汽与齿轮仍在运转的小城，维修店的老板库玛每天都和废铜烂铁打交道。某天，一个被遗弃的老式机器人抱着一颗种子走进店里，请求她帮自己「修好开花的身体」。",
      "这是一部温柔到有点笨拙的作品，讲的是修复、陪伴与告别。每一集修好一件东西，也顺带修好一个人的心。",
      "手绘质感的作画与细腻的背景音效是本作最大的魅力。",
    ],
    reasons: ["美术风格温暖，氛围感极强", "故事轻巧但不浮于表面", "适合放在「心情不好时看」的清单里"],
    staff: [
      { role: "导演", name: "木户彩花" },
      { role: "系列构成", name: "西条遥" },
      { role: "角色设计", name: "金田真里" },
      { role: "音乐", name: "铃之助" },
    ],
    characters: [
      { name: "库玛", cv: "诹访春香", desc: "维修店店主，口头禅是「修不好也别扔」。" },
      { name: "T-07", cv: "高木润", desc: "老式机器人，一生只想看到自己的花开一次。" },
      { name: "莉可", cv: "本多小夏", desc: "隔壁的花店女孩，为 T-07 提供种子。" },
    ],
    tags: ["治愈", "机器人", "手作感", "温暖"],
    studio: "铁皮工房",
  },
  {
    id: "a09",
    title: "破风之路",
    jpTitle: "ウィンド・ロード",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20sports%20poster%2C%20a%20cyclist%20in%20an%20orange%20jersey%20climbing%20a%20mountain%20road%20in%20hard%20rain%2C%20determined%20expression%2C%20dynamic%20low%20angle%2C%20dramatic%20grey%20and%20warm%20orange%20tone%2C%20detailed%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a09-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20cycling%20race%20wide%20shot%2C%20group%20of%20cyclists%20sprinting%20along%20a%20coastal%20cliff%20road%2C%20speed%20lines%20and%20motion%20blur%2C%20warm%20sunset%20orange%20light%20on%20the%20sea%2C%20dynamic%20anime%20sports%20art%2C%20no%20text&width=1600&height=900&seq=anime-a09-banner-v2&orientation=landscape",
    genres: ["运动", "热血"],
    region: "日本",
    year: 2024,
    episodes: "全 24 话",
    status: "已完结",
    rating: 8.8,
    heat: 55200,
    updatedAt: "2025-09-05",
    summary: "一支濒临解散的高中自行车队，用一年时间冲上全国赛的终点线。",
    intro: [
      "风丘高中自行车部只剩四名成员，部室还是废弃的仓库。新来的教练只说了一句话：「今年，我们打进全国赛。」",
      "作品对公路车的器械、坡度、齿比、体力分配都有相当细致的描写，同时保留了少年漫画式的热血。每一次爬坡都配合着主角的呼吸节奏剪辑，代入感极强。",
      "最后一集的终点冲刺让不少观众在屏幕前站了起来，是近年运动番里相当扎实的一部。",
    ],
    reasons: ["比赛演出节奏感极佳", "对自行车运动的描写专业又不枯燥", "群像成长线完整"],
    staff: [
      { role: "导演", name: "岩下润" },
      { role: "系列构成", name: "坂本恒一" },
      { role: "角色设计", name: "奥村光" },
      { role: "音乐", name: "TEAM SPOKE" },
    ],
    characters: [
      { name: "风间陆", cv: "石田航", desc: "带队爬坡的王牌，最怕的是下坡。" },
      { name: "小暮凛", cv: "森川遥", desc: "冲刺手，性格张扬，比赛里最爱笑。" },
      { name: "教练", cv: "木村亘", desc: "前职业车手，说话很少，做事很准。" },
    ],
    tags: ["自行车", "竞技", "青春", "热血"],
    studio: "风丘制作",
  },
  {
    id: "a10",
    title: "深海图书馆",
    jpTitle: "深海の図書館",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20fantasy%20poster%2C%20a%20young%20librarian%20in%20a%20navy%20coat%20holding%20a%20glowing%20book%2C%20standing%20inside%20a%20vast%20underwater%20library%20with%20tall%20bookshelves%20and%20fish%20swimming%20between%20them%2C%20deep%20teal%20and%20warm%20amber%20accents%2C%20vertical%20composition%2C%20detailed%20anime%20illustration&width=600&height=850&seq=anime-a10-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20underwater%20library%20wide%20shot%2C%20enormous%20arch%20windows%20with%20fish%20swimming%20outside%2C%20floating%20books%20and%20warm%20amber%20lamps%2C%20deep%20teal%20water%20light%2C%20cinematic%20anime%20fantasy%20background%20art%2C%20no%20text&width=1600&height=900&seq=anime-a10-banner-v2&orientation=landscape",
    genres: ["奇幻", "悬疑", "治愈"],
    region: "中国",
    year: 2025,
    episodes: "全 16 话",
    status: "连载中",
    rating: 8.9,
    heat: 70400,
    updatedAt: "2025-10-11",
    summary: "海底深处有一座图书馆，收藏着所有「没有被写下」的故事。",
    intro: [
      "深海图书馆只在海面起雾时向陆地上的人开放。管理员小舟的工作是整理那些没人写下的故事，把它们放回书架，等它们自己找到主人。",
      "本作的单元结构很特别：每一集由一本「无名之书」展开，观众需要跟着主角一起猜这本书属于谁。谜底往往温柔又意外。",
      "美术上以深海青绿与暖琥珀灯光为主，视觉沉浸感很强，是今年国产奇幻动画里辨识度相当高的一部。",
    ],
    reasons: ["设定浪漫，单元故事的解法令人惊喜", "深海场景美术极为出色", "配乐使用大量弦乐与环境音，沉浸感强"],
    staff: [
      { role: "导演", name: "沈知白" },
      { role: "编剧", name: "夏一苇" },
      { role: "美术总监", name: "何莲" },
      { role: "音乐", name: "深海回声" },
    ],
    characters: [
      { name: "小舟", cv: "陆轻语", desc: "深海图书馆管理员，怕黑但从不承认。" },
      { name: "墨先生", cv: "钟离砚", desc: "图书馆的守门人，本体大概是一支钢笔。" },
      { name: "白鳍", cv: "苏念", desc: "会说话的鱼，负责把读者带到正确的书架。" },
    ],
    tags: ["深海", "图书馆", "单元剧", "浪漫"],
    studio: "知白映画",
  },
  {
    id: "a11",
    title: "午夜便利店",
    jpTitle: "ミッドナイト・マート",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20urban%20night%20poster%2C%20a%20convenience%20store%20glowing%20on%20an%20empty%20city%20street%20at%20midnight%2C%20a%20clerk%20in%20a%20green%20vest%20standing%20by%20the%20window%2C%20warm%20interior%20light%20against%20cool%20night%20tones%2C%20cinematic%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a11-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20night%20city%20wide%20shot%2C%20convenience%20store%20glowing%20warm%20amber%20on%20a%20rain%20slick%20street%2C%20neon%20signs%20in%20soft%20muted%20colors%2C%20one%20customer%20walking%20in%2C%20cinematic%20urban%20anime%20background%2C%20no%20text&width=1600&height=900&seq=anime-a11-banner-v2&orientation=landscape",
    genres: ["日常", "奇幻", "治愈"],
    region: "日本",
    year: 2021,
    episodes: "全 12 话",
    status: "已完结",
    rating: 8.3,
    heat: 32800,
    updatedAt: "2025-05-09",
    summary: "凌晨两点到四点的便利店，会有一些不太像人类的客人推门进来。",
    intro: [
      "新入职的店员葵被前辈提醒：「夜班的时候，不要问客人的名字。」于是她开始遇见各式各样的客人：买了十二瓶牛奶的幽灵、只买一颗糖的狐狸、要用硬币支付一杯咖啡的时间旅行者。",
      "作品用日常的方式讲超日常的事，氛围轻松又带一点点孤独。每个客人背后都有一个短短的、关于告别的故事。",
      "如果你喜欢都市夜景与温暖小故事，这部很适合在通勤路上看。",
    ],
    reasons: ["都市夜景色调极具氛围感", "单元故事轻巧有趣，观感轻松", "片尾曲与画面搭配极佳"],
    staff: [
      { role: "导演", name: "矢野凉" },
      { role: "系列构成", name: "小池直树" },
      { role: "角色设计", name: "森元立" },
      { role: "音乐", name: "夜班电台" },
    ],
    characters: [
      { name: "葵", cv: "水原日向", desc: "新来的夜班店员，适应力惊人。" },
      { name: "前辈", cv: "今井拓", desc: "夜班老手，什么都能淡定面对。" },
      { name: "白狐", cv: "无", desc: "每晚都来买同一颗糖的客人。" },
    ],
    tags: ["都市", "夜景", "单元剧", "温柔"],
    studio: "霓虹宅制作",
  },
  {
    id: "a12",
    title: "雷霆星域",
    jpTitle: "サンダー・ドメイン",
    cover:
      "https://readdy.ai/api/search-image?query=Western%20animation%20key%20visual%20poster%2C%20a%20hero%20in%20a%20bright%20orange%20armored%20suit%20holding%20a%20lightning%20spear%2C%20flying%20above%20a%20futuristic%20city%2C%20bold%20graphic%20style%2C%20clean%20simple%20background%2C%20vertical%20poster%20layout%2C%20high%20detail&width=600&height=850&seq=anime-a12-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Western%20animation%20wide%20shot%2C%20superhero%20with%20orange%20lightning%20powers%20soaring%20above%20a%20futuristic%20coastal%20city%2C%20dynamic%20perspective%2C%20bold%20graphic%20shapes%2C%20warm%20orange%20and%20cream%20palette%2C%20no%20text&width=1600&height=900&seq=anime-a12-banner-v2&orientation=landscape",
    genres: ["热血", "科幻"],
    region: "美国",
    year: 2024,
    episodes: "全 10 集",
    status: "已完结",
    rating: 8.1,
    heat: 28900,
    updatedAt: "2025-08-14",
    summary: "一位靠借来的超能力战斗的英雄，必须在每一次放电后付出代价。",
    intro: [
      "在一座被超能力者统治的海滨城市，普通工程师凯登意外获得了一种「借力」能力：他可以在短时间内借用附近超能者的力量，但用完后必须归还加倍的能量。",
      "作品以极其明快的图形化美术与强对比配色呈现，动作设计参考了美式漫画的分镜语言，整体节奏明快，适合作为轻松爽剧观看。",
      "中文配音版本的情绪表达也相当到位，是部合家欢向的超级英雄动画。",
    ],
    reasons: ["设定有趣，能力代价设计聪明", "美术风格明快，辨识度高", "节奏明快，观感轻松"],
    staff: [
      { role: "导演", name: "Derek Hale" },
      { role: "编剧", name: "Mia Rosales" },
      { role: "角色设计", name: "Jon Park" },
      { role: "音乐", name: "Neon Pulse" },
    ],
    characters: [
      { name: "凯登", cv: "刘鑫", desc: "工程师出身的借力英雄，总是先算好再动手。" },
      { name: "薇拉", cv: "周可", desc: "城市执法队的队长，能力是操控反重力。" },
      { name: "老周", cv: "黄海涛", desc: "街边修车铺老板，年轻时也是英雄。" },
    ],
    tags: ["超级英雄", "美漫风", "动作", "轻松"],
    studio: "Harbor Light Studios",
  },
  {
    id: "a13",
    title: "银月食堂",
    jpTitle: "銀月食堂",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20food%20theme%20poster%2C%20a%20warm%20small%20Japanese%20diner%20counter%20at%20night%20with%20a%20bowl%20of%20steaming%20ramen%20in%20the%20foreground%2C%20a%20young%20female%20cook%20smiling%20behind%20the%20counter%2C%20warm%20amber%20light%20and%20cream%20wood%20tones%2C%20detailed%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a13-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20cozy%20night%20street%20wide%20shot%2C%20small%20diner%20with%20a%20red%20noren%20curtain%20glowing%20warm%20amber%2C%20empty%20alley%20with%20wet%20stones%2C%20soft%20rain%2C%20warm%20cream%20and%20orange%20palette%2C%20painterly%20anime%20background%20art%2C%20no%20text&width=1600&height=900&seq=anime-a13-banner-v2&orientation=landscape",
    genres: ["日常", "治愈"],
    region: "日本",
    year: 2023,
    episodes: "全 12 话",
    status: "已完结",
    rating: 8.2,
    heat: 31200,
    updatedAt: "2025-04-22",
    summary: "只营业四小时的深夜食堂，每位客人点的那道菜，都是他人生里的一段旧事。",
    intro: [
      "银月食堂每天晚上十点开门，凌晨两点熄灯。老板娘不太说话，但总能从客人的一句「随便来点什么」里，猜出他真正想吃的菜。",
      "每一集围绕一道家常料理展开：失恋的人想吃妈妈做的蛋包饭，加班的上班族只想喝一碗撒了葱花的味噌汤。菜端上来，故事也就说完了。",
      "作品对食物作画非常认真，热气、油光与锅铲声都做得细腻，被观众说「晚上看会饿」。",
    ],
    reasons: ["美食作画细腻，氛围温暖", "每集一道菜一个故事，节奏舒适", "适合深夜放松观看"],
    staff: [
      { role: "导演", name: "村上志乃" },
      { role: "系列构成", name: "宫原灯" },
      { role: "角色设计", name: "饭田澄" },
      { role: "音乐", name: "灶台四重奏" },
    ],
    characters: [
      { name: "银月", cv: "土屋千鹤", desc: "食堂老板娘，做菜从不定菜单。" },
      { name: "小跑腿", cv: "坂井优", desc: "每天来送食材的高中生，顺便蹭饭。" },
      { name: "常客老陈", cv: "梶原久", desc: "坐最里面那张椅子，一周来五次。" },
    ],
    tags: ["美食", "深夜", "日常", "温暖"],
    studio: "灶间动画",
  },
  {
    id: "a14",
    title: "零号档案",
    jpTitle: "ゼロ・ファイル",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20thriller%20poster%2C%20a%20female%20investigator%20in%20a%20charcoal%20suit%20standing%20in%20front%20of%20a%20wall%20of%20classified%20documents%20and%20photographs%2C%20single%20warm%20lamp%2C%20muted%20grey%20and%20amber%20tones%2C%20high%20contrast%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a14-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20thriller%20wide%20shot%2C%20dim%20archive%20room%20with%20tall%20files%20and%20a%20single%20spotlight%20on%20an%20empty%20desk%2C%20muted%20charcoal%20and%20amber%20palette%2C%20cinematic%20suspense%20anime%20background%20art%2C%20no%20text&width=1600&height=900&seq=anime-a14-banner-v2&orientation=landscape",
    genres: ["悬疑", "科幻"],
    region: "中国",
    year: 2024,
    episodes: "全 12 话",
    status: "已完结",
    rating: 8.7,
    heat: 44800,
    updatedAt: "2025-08-02",
    summary: "一份编号为零的档案，指向一场从未发生的城市事故。",
    intro: [
      "档案管理局的女调查员接手了一份奇怪的卷宗：编号零，没有归档时间，也没有责任人。内容记录的却是一场发生在三年前的城市事故，而官方记录里根本没有这场事故。",
      "随着调查推进，她发现所有相关人员的记忆都存在一小段空白。是有人在删除记录，还是有人从未存在过？",
      "作品采用冷静克制的叙事，配合大量档案特写与低饱和美术，把悬念一点点推到最后一集。",
    ],
    reasons: ["悬疑铺陈细腻，反转合理", "冷调美术与档案细节考究", "主角的动机写得很有说服力"],
    staff: [
      { role: "导演", name: "韩兆" },
      { role: "编剧", name: "林不归" },
      { role: "美术总监", name: "沈砾" },
      { role: "音乐", name: "零号工作室" },
    ],
    characters: [
      { name: "苏期", cv: "许清和", desc: "档案管理局调查员，记忆力异常可靠。" },
      { name: "老吴", cv: "冯建国", desc: "档案室管理员，掌握着所有门禁的记录。" },
      { name: "零", cv: "不详", desc: "档案里反复出现的名字。" },
    ],
    tags: ["档案", "悬疑", "冷调", "反转"],
    studio: "无界映画",
  },
  {
    id: "a15",
    title: "云上的演奏厅",
    jpTitle: "雲上のホール",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20music%20poster%2C%20a%20teenage%20violinist%20standing%20in%20a%20floating%20concert%20hall%20above%20the%20clouds%2C%20dramatic%20stage%20lighting%20in%20warm%20gold%2C%20elegant%20architecture%20with%20cream%20columns%2C%20detailed%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a15-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20wide%20shot%2C%20grand%20concert%20hall%20floating%20above%20a%20sea%20of%20clouds%20at%20golden%20hour%2C%20open%20windows%20with%20curtains%20blowing%2C%20warm%20gold%20light%2C%20cinematic%20fantasy%20anime%20background%2C%20no%20text&width=1600&height=900&seq=anime-a15-banner-v2&orientation=landscape",
    genres: ["奇幻", "治愈"],
    region: "中国",
    year: 2022,
    episodes: "全 10 话",
    status: "已完结",
    rating: 8.0,
    heat: 26400,
    updatedAt: "2025-03-16",
    summary: "一座飘在云上的演奏厅，只接受还没演奏完自己人生的乐手。",
    intro: [
      "少年提琴手陆闻在一次比赛失利后，偶然走进了一座飘在云层上的演奏厅。这里有最好的音响、最安静的观众，唯一的要求是——你必须演奏自己还没写完的曲子。",
      "整部作品以音乐为主线，会出现多段完整的演奏段落，配乐由真实室内乐团录制。",
      "它并不急着讲大道理，只是安静地陪一个不自信的少年，慢慢把曲子弹完。",
    ],
    reasons: ["配乐水准高，演奏段落完整", "云上演奏厅的美术意境独特", "情绪细腻，适合安静时段观看"],
    staff: [
      { role: "导演", name: "江未" },
      { role: "编剧", name: "苏晚" },
      { role: "角色设计", name: "程岚" },
      { role: "音乐", name: "云上四重奏" },
    ],
    characters: [
      { name: "陆闻", cv: "易寒", desc: "提琴少年，拉琴前会先听一遍风。" },
      { name: "调音师", cv: "白晟", desc: "演奏厅的调音师，耳朵能听出人的心事。" },
      { name: "小观众", cv: "林希", desc: "每场演出都坐在最后一排的女孩。" },
    ],
    tags: ["音乐", "奇幻", "成长", "云上"],
    studio: "云阶动画",
  },
  {
    id: "a16",
    title: "第七声铃",
    jpTitle: "七度目のベル",
    cover:
      "https://readdy.ai/api/search-image?query=Anime%20supernatural%20poster%2C%20an%20old%20school%20bell%20tower%20at%20dusk%20with%20a%20figure%20standing%20at%20the%20window%2C%20long%20shadows%20across%20empty%20hallway%2C%20muted%20warm%20red%20and%20cream%20palette%2C%20cinematic%20anime%20illustration%2C%20vertical%20poster%20layout&width=600&height=850&seq=anime-a16-cover-v2&orientation=portrait",
    banner:
      "https://readdy.ai/api/search-image?query=Anime%20wide%20shot%2C%20empty%20old%20school%20hallway%20at%20sunset%20with%20warm%20light%20streaming%20through%20classroom%20windows%2C%20dust%20in%20the%20air%2C%20muted%20warm%20palette%2C%20quiet%20melancholic%20anime%20background%20art%2C%20no%20text&width=1600&height=900&seq=anime-a16-banner-v2&orientation=landscape",
    genres: ["悬疑", "奇幻"],
    region: "日本",
    year: 2021,
    episodes: "全 13 话",
    status: "已完结",
    rating: 8.3,
    heat: 29600,
    updatedAt: "2025-02-08",
    summary: "废校前的最后一个夏天，钟楼每天多响一次，而学校里多了一个不存在的学生。",
    intro: [
      "即将拆除的老校舍，传闻会在黄昏时分响起第七声钟。而实际上，这所学校的钟只在整点响六次。",
      "转学生梓在第七声铃响时，看见了走廊尽头的一个女孩。她穿着几十年前的校服，似乎也在等谁。",
      "作品把校园怪谈与青春告别结合，最后一集揭晓真相时，很多观众说自己在地铁上哭了出来。",
    ],
    reasons: ["校园怪谈氛围营造极好", "青春情怀与解谜结合自然", "结尾收束干净，余味很长"],
    staff: [
      { role: "导演", name: "户田直人" },
      { role: "系列构成", name: "森园律" },
      { role: "角色设计", name: "永井雫" },
      { role: "音乐", name: "钟楼回声" },
    ],
    characters: [
      { name: "梓", cv: "长谷川葵", desc: "转学生，天生能听见不属于这个时间的声音。" },
      { name: "千代", cv: "古川小夜", desc: "走廊尽头的女孩，一直没有毕业。" },
      { name: "门卫老伯", cv: "杉山正", desc: "在学校待了四十年，知道钟楼的事。" },
    ],
    tags: ["校园", "怪谈", "青春", "黄昏"],
    studio: "旧铃社",
  },
];